// src/components/SearchBar.jsx
import React, { useState } from 'react';
import { FaSearch } from 'react-icons/fa'; // Ícone de lupa

const SearchBar = ({ onSearch }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const handleChange = (e) => {
    setSearchTerm(e.target.value);
    onSearch(e.target.value);
  };

  return (
    <div className="search-bar">
      <div className="input-container">
        <input
          type="text"
          placeholder="Pesquisar por título ou ID..."
          value={searchTerm}
          onChange={handleChange}
        />
        {/* Ícone à esquerda */}
        <FaSearch className="search-icon-right" />
      </div>
    </div>
  );
};

export default SearchBar;